import { Brick, registerBrick } from 'olympe';

/**
 * This brick dynamically builds and applies filters for Olympe DB queries through the Olympe Gateway
 */
export default class OGCreateBindingsForOlympeDB extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} table
     * @param {*} columns
     * @param {*} values
     * @param {function()} forwardEvent
     * @param {function(*)} setBindings
     */
    update($, [values], [forwardEvent, setBindings]) {
        setBindings(({bindings: values}));
        forwardEvent();
    }
}

registerBrick('0198f0e635a18649716f', OGCreateBindingsForOlympeDB);
